import {
  createSearchParamsCache,
  type inferParserType,
  parseAsArrayOf,
  parseAsInteger,
  parseAsString,
  parseAsStringLiteral,
} from "nuqs/server"

export type SortBy = "menu_order" | "date" | "popularity" | "rating" | "title"
export type SortOrder = "asc" | "desc"
export type ViewMode = "grid" | "list"

export const categoryServerParsers = {
  q: parseAsString.withDefault(""),
  orderby: parseAsStringLiteral<SortBy>([
    "menu_order",
    "date",
    "popularity",
    "rating",
    "title",
  ]).withDefault("popularity"),
  order: parseAsStringLiteral<SortOrder>(["asc", "desc"]).withDefault("desc"),
  page: parseAsInteger.withDefault(1),
  per_page: parseAsInteger.withDefault(12),
  store_ids: parseAsArrayOf(parseAsString, ",").withDefault([]),
  brand: parseAsString,
  min_rating: parseAsInteger,
  discount: parseAsStringLiteral(["1", "true"]),
  min_price: parseAsInteger,
  max_price: parseAsInteger,
  view: parseAsStringLiteral<ViewMode>(["grid", "list"]).withDefault("grid"),
}

export type CategoryQueryState = inferParserType<typeof categoryServerParsers>

export type SearchParamsInput = Record<string, string | string[] | undefined>

export const categorySearchParamsCache = createSearchParamsCache(
  categoryServerParsers
)

const normalizePriceRange = (state: CategoryQueryState): CategoryQueryState => {
  if (state.min_price === null || state.max_price === null) {
    return state
  }

  return {
    ...state,
    min_price: Math.min(state.min_price, state.max_price),
    max_price: Math.max(state.min_price, state.max_price),
  }
}

export const normalizeCategorySearchParams = async (
  searchParams: SearchParamsInput | Promise<SearchParamsInput>
): Promise<CategoryQueryState> => {
  const resolvedSearchParams = await Promise.resolve(searchParams)
  const parsedState = categorySearchParamsCache.parse(resolvedSearchParams)
  return normalizePriceRange(parsedState)
}
